import React, {useEffect} from 'react';


const L = window.L;

const openStreetMapMapnik = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  maxZoom: 15
});

const MapOpenStreetMap = ({Map}) => {
    
    useEffect(() => {
        
        if (!Map) return ;
        
        console.log("Adding layer? ")
        Map.addLayer(openStreetMapMapnik);

        return function cleanup() {
            Map.removeLayer(openStreetMapMapnik)
            openStreetMapMapnik.remove()

            console.log("CLEANUP CALLED", Map, openStreetMapMapnik)

        }

    }, [Map])


    return null;
}

export default MapOpenStreetMap;